

































import API from '@core/services/API'
import { inject } from 'inversify-props'
import { Component, Vue } from 'vue-property-decorator'
import { namespace } from 'vuex-class'

const kycSubmissionStore = namespace('KYCSubmissionStore')

@Component
export default class TheKycConfirmation extends Vue {
  private supervisorList = []
  private proxySupervisors = []
  private selectedSupervisorOid = ''
  private selectedProxySupervisorOid = ''

  @inject()
  private $api: API

  @kycSubmissionStore.Getter
  isSuperiorVerified

  @kycSubmissionStore.Action
  updateSuperiors!: (superiors: { supervisorOid: string; proxySupervisorOid: string }) => void

  get confirmation () {
    return this.isSuperiorVerified
  }

  // Methods

  updateSuperiors2 () {
    this.updateSuperiors({
      supervisorOid: this.selectedSupervisorOid,
      proxySupervisorOid: this.selectedProxySupervisorOid
    })
  }

  // Vue lifecycles

  async mounted () {
    const { proxySupervisors, supervisors } = await this.$api.account.getSupervisorList({})
      .then(response => {
        const data = response
        return {
          proxySupervisors: data['proxy-supervisors'],
          supervisors: data.supervisors,
          success: data.success
        }
      })
      .catch(error => {
        console.error('homeAdviser.js: Exception', error)
        alert('homeAdviser.js' + error)
      }) || {} // this is if error occured, return empty object
    this.supervisorList = supervisors
    this.proxySupervisors = proxySupervisors
    if (this.supervisorList && this.supervisorList.length > 0) { this.selectedSupervisorOid = this.supervisorList[0]._oid }
    if (this.proxySupervisors && this.proxySupervisors.length > 0) { this.selectedProxySupervisorOid = this.proxySupervisors[0]._oid }
    this.updateSuperiors2() // trigger update on mounting
  }
}
